import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.pruefcheckliste-reihenfolge-setzen';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPruefchecklisteReihenfolgeSetzenEffects {

    PruefchecklisteReihenfolgeSetzen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_PRUEFCHECKLISTE_REIHENFOLGE_SETZEN),
        mergeMap((x: ac.PostPruefchecklisteReihenfolgeSetzenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postPruefchecklisteReihenfolgeSetzen(x.pruefchecklisteReihenfolgeRequest).pipe(
                map((result: any) => {
                    return new ac.PostPruefchecklisteReihenfolgeSetzenErfolgreichAction(result, x.pruefchecklisteReihenfolgeRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostPruefchecklisteReihenfolgeSetzenFehlerAction(error, x.pruefchecklisteReihenfolgeRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
